import { MiscellaneousFormSchema } from "../../schemas/forms.js";
import { miscellaneousService } from "../../api/miscellaneous.service.js";
import type { Miscellaneous } from "../../api/miscellaneous.service.js";
import type { HierarchyManagerConfig } from "../../components/HierarchyManager/index.js";

export const miscellaneousConfig: HierarchyManagerConfig<Miscellaneous> = {
  // Display configuration
  title: "Miscellaneous",
  singularName: "Miscellaneous",
  pluralName: "Miscellaneous",

  // API service
  apiService: miscellaneousService,

  // Form fields configuration (camelCase to match UI/validation)
  formFields: [
    {
      name: "parentId",
      label: "Parent Item",
      type: "select",
      required: false,
      searchable: true,
      defaultValue: null,
    },
    {
      name: "name",
      label: "Name",
      type: "text",
      required: true,
      placeholder: "Enter item name",
      defaultValue: "",
    },
    {
      name: "code",
      label: "Code",
      type: "text",
      required: true,
      placeholder: "Enter item code (e.g., GENERAL, OTHER)",
      defaultValue: "",
    },
    {
      name: "displayOrder",
      label: "Display Order",
      type: "number",
      required: false,
      defaultValue: 0,
      helperText: "Lower numbers appear first",
    },
  ],

  // Validation schema from shared package (camelCase)
  validationSchema: MiscellaneousFormSchema,

  // Feature flags
  enableDragAndDrop: true,
  enableSearch: true,
  enableBreadcrumbs: true,
  showCode: true,
};
